var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poster-box"},[_c('div',{staticClass:"picture-area"},[_c('WebpImage',{attrs:{"imageInfo":{
        imageUrl: _vm.posterImage,
        width: 1240,
        height: 698,
        className: 'poster-thumb',
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }